import { Language } from './../types/helpers/language.model';
import { Skill } from './../types/helpers/skill.model';
import { Component, OnInit } from '@angular/core';
import { User } from '../types/user.model';
import { ProfileService } from '../profile.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mmb-web-app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
  user: User;
  skills: Observable<Skill> = this.profileService.getUserSkills();
  languages: Observable<Language> = this.profileService.getUserLanguages();
  requests: Observable<any> = this.profileService.getUserRequests();
  offers: Observable<any> = this.profileService.getUserOffers();
  menuCollapsed: boolean = true;

  menuItems = [
    "About Me", "Identity", "Interests", "Experience", "Account", "Notifications"
  ];

  activeLink = 0;

  constructor(private profileService: ProfileService, private route: ActivatedRoute) { }

  ngOnInit() {
    this._getUser();

    this.route.queryParams.subscribe((params) => {
      if (params) {
        this.activeLink = params['tab'] ? parseInt(params['tab']) : 0;
      }
    })
  }

  navigateMenu(i: number) {
    this.activeLink = i;
  }

  onUpdateUser() {
    this._getUser();
  }

  private _getUser() {
    this.profileService.userProfile$.subscribe((response) => {
      this.user = response;
    })
  }
}
